import { useState, useRef, useCallback, useEffect } from 'react';
export function useDynamicInputMask({ value: inputValue, delay = 500, enabled, onChange }) {
    const [value, setValue] = useState('');
    const [displayValue, setDisplayValue] = useState('');
    const cursorPosition = useRef(null);
    const timeouts = useRef({});
    // Сбросить все таймеры
    const clearAllTimeouts = useCallback(() => {
        Object.values(timeouts.current).forEach(clearTimeout);
        timeouts.current = {};
    }, []);
    useEffect(() => {
        if (inputValue !== value) {
            setValue(inputValue);
        }
    }, [inputValue]);
    // Сброс таймеров при размонтировании
    useEffect(() => {
        return () => {
            clearAllTimeouts();
        };
    }, [clearAllTimeouts]);
    // Обработка изменения значения
    const onChangeHandler = useCallback((e) => {
        var _a;
        const input = e.target;
        if (!enabled) {
            onChange(e);
            setValue(input.value);
            setDisplayValue(input.value.split('').fill('•').join(''));
            return;
        }
        const newValue = input.value;
        const oldValue = value;
        if (!newValue && oldValue) {
            onChange(e);
            setValue('');
            setDisplayValue('');
            return;
        }
        const diffLength = newValue.length - oldValue.length;
        const cursor = (_a = input.selectionStart) !== null && _a !== void 0 ? _a : newValue.length;
        cursorPosition.current = cursor;
        let updatedValue = oldValue;
        // Добавление символа
        if (newValue.length > oldValue.length) {
            const addPos = cursor - diffLength;
            const addedChars = newValue.slice(addPos, cursor);
            updatedValue = oldValue.slice(0, addPos) + addedChars + oldValue.slice(addPos);
            setDisplayValue(prevValue => prevValue.slice(0, addPos) + addedChars + prevValue.slice(addPos));
            // Очищаем существующие таймеры для затрагиваемых позиций
            for (let i = addPos; i < addPos + addedChars.length; i++) {
                if (timeouts.current[i]) {
                    clearTimeout(timeouts.current[i]);
                }
            }
            // Устанавливаем новые таймеры
            addedChars.split('').forEach((_, index) => {
                const position = addPos + index;
                timeouts.current[position] = setTimeout(() => {
                    setDisplayValue(currentValue => {
                        const arr = currentValue.split('');
                        arr[position] = '•';
                        return arr.join('');
                    });
                    input.setSelectionRange(cursorPosition.current, cursorPosition.current);
                    // tslint:disable-next-line:no-dynamic-delete
                    delete timeouts.current[position];
                }, delay);
            });
        }
        // Удаление символа
        else if (newValue.length < oldValue.length) {
            const delPos = cursor;
            const deletedCount = Math.abs(diffLength);
            updatedValue = oldValue.slice(0, delPos) + oldValue.slice(delPos + deletedCount);
            setDisplayValue(prevValue => prevValue.slice(0, delPos) + prevValue.slice(delPos + deletedCount));
            // Очищаем таймеры для удаленных и сдвинутых позиций
            Object.keys(timeouts.current).forEach(charPos => {
                const pos = Number(charPos);
                if (pos >= delPos) {
                    clearTimeout(timeouts.current[pos]);
                    // tslint:disable-next-line:no-dynamic-delete
                    delete timeouts.current[pos];
                }
            });
        }
        e.target.value = updatedValue;
        onChange(e);
        setValue(updatedValue);
        setTimeout(() => input.setSelectionRange(cursor, cursor));
    }, [value, delay, enabled, onChange]);
    return {
        value: enabled ? displayValue : inputValue,
        onChange: onChangeHandler
    };
}
